export default [
  {
    path: "/info/apperror",
    name: "apperror",
    component: () => import("@/views/document/apperror/index.vue"),
    meta: {
      pageTitle: "AppError",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AppError",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/apperror/view/:id",
    name: "ViewAppError",
    component: () => import("@/views/document/apperror/view.vue"),
    meta: {
      pageTitle: "AppError",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AppError",
          active: true,
        },
      ],
    },
  },
]
